import React from 'react'
import { TestingTargetProp } from '@chegg-wt/core/types/react'
import * as Styled from '../styled'

import { BaseModalProps } from '../BaseModal'

export interface DeleteModalBaseProps extends BaseModalProps, TestingTargetProp {
  title: string
  description: string
  handleConfirm: (any) => void
}

export const DEFAULT_DELETE_MODAL_TEST_ID = 'delete-modal'

export const DeleteModalBase: React.FunctionComponent<DeleteModalBaseProps> = ({
  title,
  description,
  handleConfirm,
  handleClose,
  testId = DEFAULT_DELETE_MODAL_TEST_ID,
}) => (
  <Styled.Container>
    <Styled.Heading data-test={`${testId}-title`}>{title}</Styled.Heading>
    <Styled.Message data-test={`${testId}-description`}>{description}</Styled.Message>
    <Styled.ButtonContainer>
      <Styled.CancelButton onClick={handleClose} data-test={`${testId}-cancel`}>
        Cancel
      </Styled.CancelButton>
      <Styled.ConfirmButton onClick={handleConfirm} data-test={`${testId}-confirm`}>
        Delete
      </Styled.ConfirmButton>
    </Styled.ButtonContainer>
    <Styled.ButtonContainerMobile>
      <Styled.ConfirmButton onClick={handleConfirm} data-test={`${testId}-confirm`}>
        Delete
      </Styled.ConfirmButton>
      <Styled.CancelButton onClick={handleClose} data-test={`${testId}-cancel`}>
        Cancel
      </Styled.CancelButton>
    </Styled.ButtonContainerMobile>
  </Styled.Container>
)

export default DeleteModalBase
